export enum LocalStorageKey {
  APP_TOKEN = "app-token",
  USER_TOKEN = "user-token",
  INVOICES_PATIENTS_HISTORICAL_SEARCH = "invoices_patient_historical_search",
  PAYMENT_RECEIPTS_PATIENTS_HISTORICAL_SEARCH = "payment_receipts_patient_historical_search",
  ON_BOARDING_DATA = "on_boarding_data",
  PRIVACY_ENABLED_HINT = "privacy_enabled_hint",
  PRIVACY_SECURITY_STATE = "privacy_security_state_v1",
  PRIVACY_PIN_CODE = "privacy_pin_code",
  PRIVACY_PIN_ATTEMPTS = "privacy_pin_attempts",
  PRIVACY_PIN_LOCK_LEVEL = "privacy_pin_lock_level",
  PRIVACY_PIN_LOCK_UNTIL = "privacy_pin_lock_until",
  PRIVACY_DATE = "privacy_date",
  PRIVACY_BIO = "privacy_bio",
  PRIVACY_BIO_CHECKED = "privacy_bio_checked",
  TIME_ZONE = "time_zone",
  TIME_ZONE_DATE = "time_zone_date",
}
